export default {
  buttonTitle: {
    en: 'View more scents',
  },
}
